import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=63ace8ff&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=63ace8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ace8ff",
  null
  
)

export default component.exports